import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=a4b4a7c6&"
import script from "./RichText.vue?vue&type=script&lang=ts&"
export * from "./RichText.vue?vue&type=script&lang=ts&"
import style0 from "./RichText.vue?vue&type=style&index=0&id=a4b4a7c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports